<template>
<div>

  <div class="back"></div>

  <!-- ALL -->
  <v-toolbar
          v-if="page.indexOf('malina') == -1 && page.indexOf('sadko') == -1 && page.indexOf('acropolis') == -1"
          fixed
          flat
          class="toolbar"
  >
    <v-toolbar-title class="title-title">
      <router-link to="/">
        <div class="title-box">
          <div class="title-logo"></div>
          <div>
            <div class="title-name">
              &#171;МАЛИНА - САДКО&#187;
            </div>
            <div class="title-subname">
              сауны и гостиницы Новокузнецка
            </div>
          </div>
        </div>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-menu
            bottom
            left
    >
      <template v-slot:activator="{ on }">
        <v-btn
                color="grey lighten-2"
                class="toolbar-menu-btn hidden-md-and-up"
                depressed
                v-on="on"
        >
          Адреса
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
                v-for="link in mainLinks"
                :key="link.title"
                :to="link.url"
        >
          <v-list-tile-title>{{ link.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn
              v-for="link in mainLinks"
              :key="link.title"
              :to="link.url"
              flat
      >
        {{ link.title }}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>

  <!-- MALINA -->
  <v-toolbar
          v-if="page.indexOf('malina') != -1"
          fixed
          flat
          class="toolbar"
  >
    <v-toolbar-title class="title-title">
      <router-link to="/malina">
        <div class="title-box">
          <div class="title-logo"></div>
          <div>
            <div class="title-name">
              &#171;МАЛИНА&#187;
            </div>
            <div class="title-subname">
              гостиница - сауна - хаммам
            </div>
          </div>
        </div>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-menu
            bottom
            left
    >
      <template v-slot:activator="{ on }">
        <v-btn
                color="grey lighten-2"
                class="toolbar-menu-btn hidden-md-and-up"
                depressed
                v-on="on"
        >
          Адреса
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
                v-for="link in mainLinks"
                :key="link.title"
                :to="link.url"
        >
          <v-list-tile-title>{{ link.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn
        v-for="link in mainLinks"
        :key="link.title"
        :to="link.url"
        flat
      >
        {{ link.title }}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>

  <!-- SADKO -->
  <v-toolbar
          v-if="page.indexOf('sadko') != -1"
          fixed
          flat
          class="toolbar"
  >
    <v-toolbar-title class="title-title">
      <router-link to="/sadko">
        <div class="title-box">
          <div class="title-logo-sadko"></div>
          <div>
            <div class="title-name">
              &#171;САДКО&#187;
            </div>
            <div class="title-subname">
              сауна
            </div>
          </div>
        </div>
      </router-link>
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-menu
            bottom
            left
    >
      <template v-slot:activator="{ on }">
        <v-btn
                color="grey lighten-2"
                class="toolbar-menu-btn hidden-md-and-up"
                depressed
                v-on="on"
        >
          Адреса
        </v-btn>
      </template>
      <v-list>
        <v-list-tile
                v-for="link in mainLinks"
                :key="link.title"
                :to="link.url"
        >
          <v-list-tile-title>{{ link.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn
              v-for="link in mainLinks"
              :key="link.title"
              :to="link.url"
              flat
      >
        {{ link.title }}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>

  <!-- ACROPOLIS -->
<!--  <v-toolbar-->
<!--          v-if="page.indexOf('acropolis') != -1"-->
<!--          fixed-->
<!--          flat-->
<!--          class="toolbar"-->
<!--  >-->
<!--    <v-toolbar-title class="title-title">-->
<!--      <router-link to="/acropolis">-->
<!--        <div class="title-box">-->
<!--          <div class="title-logo-acropolis"></div>-->
<!--          <div>-->
<!--            <div class="title-name">-->
<!--              &#171;АКРОПОЛЬ&#187;-->
<!--            </div>-->
<!--            <div class="title-subname">-->
<!--              сауна и кафе-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </router-link>-->
<!--    </v-toolbar-title>-->
<!--    <v-spacer></v-spacer>-->

<!--    <v-menu-->
<!--            bottom-->
<!--            left-->
<!--    >-->
<!--      <template v-slot:activator="{ on }">-->
<!--        <v-btn-->
<!--                color="grey lighten-2"-->
<!--                class="toolbar-menu-btn hidden-md-and-up"-->
<!--                depressed-->
<!--                v-on="on"-->
<!--        >-->
<!--          Адреса-->
<!--        </v-btn>-->
<!--      </template>-->
<!--      <v-list>-->
<!--        <v-list-tile-->
<!--                v-for="link in mainLinks"-->
<!--                :key="link.title"-->
<!--                :to="link.url"-->
<!--        >-->
<!--          <v-list-tile-title>{{ link.title }}</v-list-tile-title>-->
<!--        </v-list-tile>-->
<!--      </v-list>-->
<!--    </v-menu>-->

<!--    <v-toolbar-items class="hidden-sm-and-down">-->
<!--      <v-btn-->
<!--              v-for="link in mainLinks"-->
<!--              :key="link.title"-->
<!--              :to="link.url"-->
<!--              flat-->
<!--      >-->
<!--        {{ link.title }}-->
<!--      </v-btn>-->
<!--    </v-toolbar-items>-->
<!--  </v-toolbar>-->

</div>
</template>

<script>
export default {
  computed: {
    mainLinks () {
      return this.$store.state.mainLinks
    },
    page () {
      return this.$route.path
    }
  },
  methods: {

  }
}
</script>

<style scoped>
a,
a:hover,
a:visited,
a:active {
  color: black;
  text-decoration: none;
}

.back {
  height: 64px;
}

.toolbar {
  z-index: 100;
  background-color: #FFFFFF;
}

.title-title {
  margin-left: 10px;
}

.title-box {
    display: flex;
    margin: 0;
}

.title-logo {
  width: 55px;
  height: 55px;
  background-image: url('/static/img/logos/malina.png');
  background-size: auto 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  margin-right: 5px;
}

.title-logo-sadko {
  width: 55px;
  height: 55px;
  background-image: url('/static/img/logos/sadko.jpg');
  background-size: auto 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  margin-right: 5px;
}

.title-logo-acropolis {
  width: 55px;
  height: 55px;
  background-image: url('/static/img/logos/acropolis.jpg');
  background-size: auto 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  margin-right: 5px;
}

.title-name {
  font-size: 19px;
}

.title-subname {
  font-size: 14px;
}

.toolbar-menu-btn {
  position: relative;
  height: 64px;
  margin: 0;
}

/* EXTRA SMALL */
@media (max-width: 600px) {
  .toolbar-menu-btn {
    background-color: #E0E0E0;
    width: 50px;
    height: 50px !important;
    position: relative;
  }

  .title-name {
    font-size: 13px !important;
  }

  .title-subname {
    font-size: 11px !important;
  }
}

/* SMALL */
@media (max-width: 960px) {
  .back {
    height: 48px;
  }

  .title-title {
    margin-left: 0px;
  }

  .title-logo {
    width: 40px;
    height: 40px;
  }

  .title-logo-sadko {
    width: 40px;
    height: 40px;
  }

  .title-logo-acropolis {
    width: 40px;
    height: 40px;
  }

  .title-name {
    font-size: 17px;
  }

  .toolbar-menu-btn {
    background-color: #E0E0E0;
    width: 50px;
    height: 48px;
    position: relative;
  }
}

/* MEDIUM */
@media (max-width: 1264px) {

}

/* LARGE */
@media (max-width: 1904px) {

}

/* X LARGE */
@media (min-width: 1904px) {

}

</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue